import { allPageTypes } from './interfaces';
import { pathPrefix } from './routes';

export const ifCRMcampaign = (pc?: string | null) => {
  return pc?.startsWith('crm_exp');
};
// Current blog setup
export const setDataSection = (category: string): string => {
  switch (category) {
    case '':
      return 'home';
    case 'crm':
      return 'crm';
    case 'banking':
    case 'saving-account':
    case 'checking-account':
    case 'cd':
    case 'money-market':
      return 'banking';
    case 'credit-advice':
    case 'improve-credit':
    case 'life-stages':
    case 'death-of-a-relative':
    case 'divorce':
    case 'employment':
    case 'establishing-credit':
    case 'kids':
    case 'marriage':
    case 'students':
    case 'report-advice':
    case 'bankruptcy':
    case 'charge-off':
    case 'closed-accounts':
    case 'collections':
    case 'cosigning':
    case 'credit-limit':
    case 'credit-repair':
    case 'denied-credit':
    case 'dispute':
    case 'foreclosure':
    case 'inquiry':
    case 'late-payment':
    case 'negative-information':
    case 'report-details':
    case 'repossession':
    case 'score-advice':
    case 'score-guide':
      return 'credit-report-scores';
    case 'fraud-and-identity-theft':
    case 'cybersecurity':
    case 'data-breach':
    case 'fraud-alert':
    case 'prevention':
    case 'security-freeze':
      return 'fraud-identity-theft';
    case 'personal-finance':
    case 'budgeting':
    case 'debt':
    case 'investing':
    case 'retirement':
    case 'saving':
    case 'taxes':
      return 'personal-finance';
    case 'mortgage':
    case 'mortgage-basics':
    case 'rates-and-affordability':
    case 'rentals':
    case 'heloc':
    case 'refinance':
      return 'housing';
    case 'credit-cards':
    case 'apr':
    case 'balance-transfers':
    case 'best-credit-cards':
    case 'cash-back-credit-cards':
    case 'credit-card-basics':
    case 'credit-card-reviews':
    case 'rewards-credit-cards':
    case 'secured-credit-cards':
    case 'student-credit-cards':
    case 'travel-credit-cards':
      return 'credit-cards';
    case 'loans':
    case 'auto-loans':
    case 'best-loans':
    case 'loan-basics':
    case 'loan-reviews':
    case 'personal-loans':
    case 'student-loans':
      return 'loans';
    case 'insurance':
    case 'auto-insurance':
    case 'health-insurance':
    case 'home-insurance':
    case 'insurance-reviews':
    case 'life-insurance':
    case 'pet-insurance':
      return 'insurance';
    case 'small-business':
      return 'small-business';
    case 'news-trends':
    case 'products':
    case 'research':
      return 'news-trends';
    case 'calculators':
      return 'tools';
    default:
      return 'uncategorized';
  }
};

export interface IEcsSiteSection {
  authName?: string;
  section?: string;
  category?: string;
  quinn?: string;
  savings?: string;
}

export const linkTrackingConfig: { [key: string]: string } = {
  '/credit/credit-report/': 'ae-link-fcr',
  '/credit/credit-score/': 'ae-link-fcs',
  '/credit/score-boost/': 'ae-link-bst',
  '/credit/experian-go/': 'ae-link-go',
  '/protection/identity-theft-and-credit-protection/': 'ae-link-itp',
  '/protection/free-dark-web-email-scan/': 'ae-link-dw',
  '/protection/personal-privacy-scan/': 'ae-link-pps',
  '/money/experian-smart-money/': 'ae-link-esm',
  '/money/manage-bills-subscriptions/': 'ae-link-bfx',
  '/credit-cards/': 'ae-link-crd',
  '/loans/': 'ae-link-lon',
  '/insurance/car-insurance-quotes/': 'ae-link-ciq',
  '/help/login.html': 'ae-link-log',
  '/help/credit-freeze/': 'ae-link-frz',
  '/help/fraud-alert/': 'ae-link-frd',
  '/disputes/main.html': 'ae-link-dis',
  '/reportaccess/': 'ae-link-rac',
  '/help/annual-credit-report.html': 'ae-link-acr',
  '/lp/military.html': 'ae-link-mil'
};

export const setEcsSiteSectionAuthName = (slug: string) => {
  // to return the first char of the first  name + last name
  // Split the name at the first hyphen
  const parts = slug.split('-');
  // Get the first character of the first part
  const firstChar = parts[0].charAt(0);
  // Remove the first part and combine the rest
  parts.shift();
  return ':auth-' + firstChar + '-' + parts.join('-');
};
export const setEcsSiteSection = (pageType: allPageTypes, data: IEcsSiteSection): string => {
  const base = 'expcom:consumer:ask-experian';

  if (pageType === 'home') {
    return base;
  }
  if (pageType === 'author') {
    return `${base}:author:${data.authName}`;
  }
  if (pageType === 'score-guide') {
    const dataSection = data.section;
    const dataCategory = data.category;
    return `${base}:${dataSection}:${dataCategory}`;
  }
  if (pageType === 'category') {
    const dataSection = data.section;
    const dataCategory = data.category;
    if (dataSection === dataCategory) {
      return `${base}:${dataSection}`;
    }
    return `${base}:${dataSection}:${dataCategory}`;
  }
  if (pageType === 'single') {
    const dataSection = data.section;
    const dataCategory = data.category;
    const ctaQuinn = data.quinn ? ':qs-' + data.quinn : '';
    const savings = data.savings ? `:sg-${data.savings}` : '';
    const authName = data.authName ? setEcsSiteSectionAuthName(data.authName) : '';

    if (dataSection === dataCategory) {
      return `${base}:${dataSection}${authName}${ctaQuinn}`;
    }
    return `${base}:${dataSection}:${dataCategory}${authName}${ctaQuinn}${savings}`;
  }
  if (pageType === 'calculators') {
    const dataSection = 'tools';
    const dataCategory = 'calculators';
    return `${base}:${dataSection}:${dataCategory}`;
  }
  return `${base}:uncategorized`;
};

export const addAlternateHreflang = (hrefLang: string, uri: string) => {
  const EXP_HOST = `${process.env.EXP_HOST}`;
  if (hrefLang?.includes('US:')) {
    const lang = hrefLang.replace('US:', '');
    return `<link rel="alternate" href="${EXP_HOST}${pathPrefix}${lang}" hreflang="en-us" /><link rel="alternate" href="${EXP_HOST}${pathPrefix}${uri}" hreflang="es-us" />`;
  }
  if (hrefLang?.includes('SP:')) {
    const lang = hrefLang.replace('SP:', '');
    return `<link rel="alternate" href="${EXP_HOST}${pathPrefix}${lang}" hreflang="es-us" /><link rel="alternate" href="${EXP_HOST}${pathPrefix}${uri}" hreflang="en-us" />`;
  }
  if (hrefLang?.includes('UK:')) {
    const lang = hrefLang.replace('UK:', '');
    return `<link rel="alternate" href="${EXP_HOST}${pathPrefix}${uri}" hreflang="en-us" /><link rel="alternate" href="${lang}" hreflang="en-gb" />`;
  }
  return '';
};

export const addLinkTrackingAttributes = (
  node: any,
  categoryId: string,
  articleId: string
): void => {
  const href = node.attribs.href;

  for (const urlPattern in linkTrackingConfig) {
    if (href.includes(urlPattern)) {
      if (!node.attribs) node.attribs = {};
      node.attribs['data-link-both'] =
        `${linkTrackingConfig[urlPattern]}-${categoryId}-${articleId}`;
      break;
    }
  }
};
